
<div [class]="appService.selectedTheme? 'dhl-theme':'ford-theme'" class="main-container">
  @if (router.url !== '/' && router.url !=='/login') {
    <app-header></app-header>
  }
  <div class="body-container">
    <router-outlet></router-outlet>
  </div>
  @if (router.url !== '/' && router.url !=='/login') {
    <app-footer></app-footer>
  }
</div>
